<!-- @format -->

<template>
	<pcp-user-picker
		ref="userPickerRef"
		v-model="userValue"
		style="width: 100%"
		:dialog-props="dialogProps"
		@on-confirm="onConfirm"
		@on-select="onSelect"
	>
		<template #default="{ onClick, ...args }">
			<el-input :model-value="value.toString()" placeholder="请选择用户" v-bind="args" @click="onShowUser(onClick)" />
		</template>
		<template #detail>
			<el-select
				multiple
				:model-value="linkFieldsValue"
				:teleported="false"
				class="selectUserClass"
				popper-class="selectUserPopper"
				@remove-tag="onRemove"
			/>
		</template>
	</pcp-user-picker>
</template>

<script setup lang="ts">
	import { getCheckRowsToFormDatas, getFormDatasToStrArr, getStrArrToFormDatas } from '../utils/user';
	import { PcpUserPicker } from '@/p-components';
	import { flatArr } from '@/utils';

	interface Props {
		modelValue: string;
		options: any;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const setFieldsValue = inject<(fields: Record<string, any>) => void>('setFieldsValue', () => {});
	const widgetDatas = inject<any[]>('widgetDatas', []);
	const formDatas = inject<any>('formDatas', {});

	const dialogProps = {
		'append-to-body': false,
		class: 'pickerClass',
		width: '830px',
	};

	const userPickerRef = ref<InstanceType<typeof PcpUserPicker>>();

	const userValue = ref([]);

	const value = computed({
		get() {
			return props.modelValue ? props.modelValue?.split(',').map((i) => (isNaN(+i) ? i : +i)) : [];
		},
		set(value) {
			emit('update:modelValue', value?.toString());
		},
	});

	const linkFieldsValue = ref<string[]>([]);

	const flatWigetDatas = computed(() => flatArr(widgetDatas || []));

	const onShowUser = (callback) => {
		const list = getFormDatasToStrArr(props.options.linkConfig, flatWigetDatas.value, formDatas.value);
		//console.log(list);
		linkFieldsValue.value = list;
		callback();
	};

	const onSelect = (checkRows) => {
		if (checkRows.value.length) {
			const formDatas = getCheckRowsToFormDatas(props.options.linkConfig, flatWigetDatas.value, checkRows.value);
			const values = getFormDatasToStrArr(props.options.linkConfig, flatWigetDatas.value, formDatas);

			const list = Array.from(new Set([...linkFieldsValue.value, ...values]));

			linkFieldsValue.value = list;
		}
	};

	const onRemove = (e) => {
		linkFieldsValue.value = linkFieldsValue.value.filter((i) => i !== e);
	};

	const onConfirm = (_, __) => {
		const fields = getStrArrToFormDatas(props.options.linkConfig, flatWigetDatas.value, linkFieldsValue.value);
		//console.log(fields, flatWigetDatas.value, props.options.linkConfig);
		setFieldsValue && setFieldsValue(fields);
		userPickerRef.value!.checkRows = [];
	};
</script>

<style lang="scss" scoped>
	.selectUserClass {
		width: 100%;
		margin-bottom: 10px;

		:deep(.selectUserPopper) {
			visibility: hidden;
		}
	}
</style>

<style lang="scss">
	.pickerClass {
		.el-form {
			margin-bottom: 18px;
		}
	}
</style>
